import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { WorklynxIcon } from '@/components/icons/WorklynxIcon';

interface SessionTimeoutDialogProps {
  open: boolean;
  remainingMs: number;
  onStaySignedIn: () => void;
  onSignOut: () => void;
}

export function SessionTimeoutDialog({
  open,
  remainingMs,
  onStaySignedIn,
  onSignOut,
}: SessionTimeoutDialogProps) {
  const remainingSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onStaySignedIn()}>
      <DialogContent className="max-w-md" onEscapeKeyDown={(event) => event.preventDefault()}>
        <DialogHeader>
          <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-warning/15 text-warning">
            <WorklynxIcon name="roles" size={20} />
          </div>
          <DialogTitle>Your session is about to expire</DialogTitle>
          <DialogDescription>
            For your security, WorkLynx signs out inactive sessions after 30 minutes. Activity in
            any open WorkLynx tab keeps this browser session active.
          </DialogDescription>
        </DialogHeader>

        <div className="flex items-center justify-between gap-4 px-5 py-6">
          <div>
            <p className="text-xs font-semibold uppercase text-muted">Time remaining</p>
            <p className="mt-1 text-3xl font-bold tabular-nums text-foreground">
              {minutes}:{String(seconds).padStart(2, '0')}
            </p>
          </div>
          <WorklynxIcon name="time" size={32} className="text-warning" />
        </div>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={onSignOut}>
            Sign out now
          </Button>
          <Button type="button" onClick={onStaySignedIn} autoFocus>
            Stay signed in
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
